import SystemCampaignDonateByCheck from '~/javascripts/components/DonateForm/SystemCampaignDonateByCheck';
import UserCampaignDonateByCheck from '~/javascripts/components/DonateForm/UserCampaignDonateByCheck';
import t from '~/javascripts/utils/translation';
import { observer } from 'mobx-react';
import { useState } from 'react';

const DonateByCheck = observer(
  ({ campaignName, campaignCheckCode, isSystemCampaign }) => {
    const [show, setShow] = useState(false);

    const handleClick = () => {
      setShow(true);
    };

    const handleClose = () => {
      setShow(false);
    };

    return (
      <>
        <>
          <a className='donate-by-check h80' onClick={handleClick}>
            {t('views.donate_form.give_by_check')}
          </a>
          <span className='80'>&nbsp;&#8226;&nbsp;</span>
        </>
        {show && !isSystemCampaign && (
          <UserCampaignDonateByCheck
            campaignCheckCode={campaignCheckCode}
            campaignName={campaignName}
            handleClose={handleClose}
          />
        )}
        {show && isSystemCampaign && (
          <SystemCampaignDonateByCheck handleClose={handleClose} />
        )}
      </>
    );
  }
);

export default DonateByCheck;
